"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ChannelsPage = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("react");
var react_redux_1 = require("react-redux");
var react_router_dom_1 = require("react-router-dom");
var console_1 = require("../../../../reducers/slices/console");
var all_channels_1 = __importDefault(require("./components/all_channels"));
var shopify_store_list_1 = __importDefault(require("./components/shopify/shopify_store_list"));
var uber_store_list_1 = require("./components/uber/uber_store_list");
var gmc_store_component_1 = __importDefault(require("./components/gmc/gmc_store_component"));
var ChannelsPage = function () {
    var dispatch = (0, react_redux_1.useDispatch)();
    (0, react_1.useEffect)(function () {
        dispatch((0, console_1.setPageTitle)("Channels"));
    }, []);
    return (0, react_router_dom_1.useRoutes)([
        { path: "/shopify", element: (0, jsx_runtime_1.jsx)(shopify_store_list_1.default, {}) },
        { path: "/uber", element: (0, jsx_runtime_1.jsx)(uber_store_list_1.UberStoreListComponent, {}) },
        { path: "/gmc", element: (0, jsx_runtime_1.jsx)(gmc_store_component_1.default, {}) },
        { path: "/google", element: (0, jsx_runtime_1.jsx)("div", { children: "Google" }) },
        { path: "/facebook", element: (0, jsx_runtime_1.jsx)("div", { children: "Facebook" }) },
        { path: "/", element: (0, jsx_runtime_1.jsx)(all_channels_1.default, {}) },
    ]);
};
exports.ChannelsPage = ChannelsPage;
